import { useSearchParams } from 'react-router-dom';
import './Page.css';
import './Contact.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xbdwvgzp';

function Contact() {
  const [params] = useSearchParams();
  const sent = params.get('sent') === '1';
  const nextUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/contact?sent=1`
      : '/contact?sent=1';

  return (
    <main className="page">
      <h1>Contact</h1>

      {sent ? (
        <div className="contact-success">
          <p>Thanks &mdash; your message is on its way. We'll be in touch.</p>
        </div>
      ) : (
        <>
          <p>
            Questions, feedback, or want to say hi? Drop us a note and we'll
            get back to you.
          </p>
          <form
            className="contact-form"
            action={FORMSPREE_ENDPOINT}
            method="POST"
          >
            <input type="hidden" name="_subject" value="ursix.co contact form" />
            <input type="hidden" name="_next" value={nextUrl} />
            <input
              type="text"
              name="_gotcha"
              tabIndex="-1"
              autoComplete="off"
              style={{ display: 'none' }}
            />

            <label className="contact-field">
              <span>Name</span>
              <input type="text" name="name" required />
            </label>
            <label className="contact-field">
              <span>Email</span>
              <input type="email" name="email" required />
            </label>
            <label className="contact-field">
              <span>Message</span>
              <textarea name="message" rows="6" required />
            </label>

            <button type="submit" className="contact-submit">
              Send
            </button>
          </form>
        </>
      )}
    </main>
  );
}

export default Contact;
